import styled from "@emotion/styled"
import * as button from "css/buttons"
import getMediaQuery from "css/breakpoints"
import useSSR from "hooks/useSSR"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"

const Button = styled.button`
  ${button.buttonFilled}
  ${button.opaqueGreen}
  display: flex;
  margin: 0 auto;
  margin-block-start: 6.25rem;

  ${getMediaQuery("m")} {
    margin-block-start: 11.25rem;
  }
`

export default function LegalButton({ label, aria_label }) {
  const ssr = useSSR()

  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    // if (ssr) return

    const checkRegulation = () => {
      const applied =
        window.Didomi?.isRegulationApplied('gdpr') ||
        window.Didomi?.isRegulationApplied('cpra')

      setShowButton(!!applied)
    }

    // check if Didomi is ready
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(checkRegulation)

    // recheck consent
    window.didomiEventListeners = window.didomiEventListeners || []
    window.didomiEventListeners.push({
      event: 'consent.changed',
      listener: checkRegulation,
    })

    checkRegulation()
  }, [ssr])

  if (ssr || !showButton) return null

  return (
    <Button onClick={() => process.browser && window.Didomi.preferences.show()} aria-label={aria_label}>
      {label}
    </Button>
  )
}
